<script lang="ts">
	import arrow from "@core/assets/icons/timeline/arrow.svg?raw";
	import cog from "@core/assets/icons/timeline/cog.svg?raw";
	import design from "@core/assets/icons/timeline/design.svg?raw";
	import factory from "@core/assets/icons/timeline/factory.svg?raw";
	import hardHat from "@core/assets/icons/timeline/hard hat.svg?raw";
	import screen from "@core/assets/icons/timeline/screen.svg?raw";
	import { getTranslate } from "../utils/getTranslate.js";
	import translation from "./ProcessWorkflow.translations.json" with { type: "json" };
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translation);

	const steps = [
		{ number: 1, icon: design },
		{ number: 2, icon: factory },
		{ number: 3, icon: screen },
		{ number: 4, icon: hardHat },
		{ number: 5, icon: cog },
	];
</script>

<div
	class="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:flex xl:flex-row items-center justify-between sm:gap-4 xl:gap-0"
>
	{#each steps as step, index (step.number)}
		<div class="flex flex-col xl:flex-row justify-center h-full w-2/3 sm:w-auto xl:justify-normal xl:items-center">
			<div
				class="flex flex-col text-center h-full w-full sm:w-auto xl:w-[200px] bg-white p-4 sm:p-5 xl:p-6 rounded-2xl"
			>
				<div class="w-8 h-8 rounded-full mb-3 xl:mb-4 border-2 border-zms-blue flex items-center justify-center">
					<span
						class="text-zms-blue [font-stretch:150%] {step.number === 1
							? 'ml-0.5'
							: ''} font-medium text-base/[1.2] tnum font-hubot">{step.number}</span
					>
				</div>
				<div class="mb-6 xl:mb-12 flex items-start justify-center">
					<div class="text-zms-blue w-12 sm:w-14 xl:w-16 flex items-center justify-center h-12 sm:h-14 xl:h-16">
						<Icon icon={step.icon} />
					</div>
				</div>
				<div>
					<h3 class="font-semibold text-sm sm:text-base xl:text-base text-center text-zms-dark-blue">
						{#if step.number === 1}
							{translate("step1Title")}
						{:else if step.number === 2}
							{translate("step2Title")}
						{:else if step.number === 3}
							{translate("step3Title")}
						{:else if step.number === 4}
							{translate("step4Title")}
						{:else if step.number === 5}
							{translate("step5Title")}
						{/if}
					</h3>
					{#if step.number === 5}
						<h3 class="font-semibold text-sm sm:text-base xl:text-base text-center text-zms-dark-blue">
							{translate("step5Subtitle1")}
						</h3>
						<h3 class="font-semibold text-sm sm:text-base xl:text-base text-center text-zms-dark-blue">
							{translate("step5Subtitle2")}
						</h3>
					{/if}
				</div>
			</div>

			{#if index < steps.length - 1}
				<div
					class="text-gray-400 transform xl:transform-none rotate-90 xl:rotate-0 flex-shrink-0 my-4 sm:my-0 mx-4 sm:hidden xl:block"
				>
					<Icon icon={arrow} />
				</div>
			{/if}
		</div>
	{/each}
</div>
